var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("create-view", { attrs: { "body-style": { height: "100%" } } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "details-box",
      },
      [
        _c(
          "div",
          { staticClass: "header", attrs: { slot: "header" }, slot: "header" },
          [
            _c("span", { staticClass: "text" }, [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c("i", {
              staticClass: "el-icon-close rt",
              on: { click: _vm.close },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "el-form",
              { ref: "form", attrs: { model: _vm.formData, rules: _vm.rules } },
              _vm._l(_vm.formList, function (item, index) {
                return _c(
                  "el-form-item",
                  {
                    key: index,
                    class: "el-form-item" + item.field,
                    attrs: { label: item.label, prop: item.field },
                  },
                  [
                    item.type == "date"
                      ? [
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              placeholder: "选择日期",
                            },
                            model: {
                              value: _vm.formData[item.field],
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, item.field, $$v)
                              },
                              expression: "formData[item.field]",
                            },
                          }),
                        ]
                      : item.type == "textarea"
                      ? [
                          _c("el-input", {
                            attrs: {
                              autosize: { minRows: 15 },
                              maxlength: 2000,
                              "show-word-limit": "",
                              type: "textarea",
                              placeholder: "请输入内容",
                            },
                            model: {
                              value: _vm.formData[item.field],
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, item.field, $$v)
                              },
                              expression: "formData[item.field]",
                            },
                          }),
                        ]
                      : item.type == "plus"
                      ? [
                          _c("xh-struc-user-cell", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              value: null,
                              users: _vm.formData[item.field].staff,
                              strucs: _vm.formData[item.field].dep,
                            },
                            on: { "value-change": _vm.strcUserChange },
                          }),
                        ]
                      : _c("el-input", {
                          model: {
                            value: _vm.formData[item.field],
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, item.field, $$v)
                            },
                            expression: "formData[item.field]",
                          },
                        }),
                  ],
                  2
                )
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-box" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
              [_vm._v("提交")]
            ),
            _vm._v(" "),
            _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }